import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
  // Phone Number in format: (123) 456-7890
  /**
   *
   * @description Phone Number in format: (123) 456-7890
   * @returns {*[]}
   */
  phone: () => rawVal => {
    let mask = [
      "(",
      /[1-9]/,
      /\d/,
      /\d/,
      ")",
      " ",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ]

    if (rawVal.length < 5) {
      mask[4] = /\d/;
    } else if (rawVal.length < 10) {
      mask[9] = /\d/;
    }

    return mask;
  },

  AccSpecPhone: () => rawVal => {
    let mask = [
      /[1-9]/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ]
    return mask;
  },

  ZipCode: () => rawVal => {
    let mask = [
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      "-",
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ]
    if (rawVal.length < 6) {
      mask[5] = /\d/;
    }
    return mask;
  },

  ShortZipCode: () => rawVal => {
    let mask = [
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/,
      /[0-9]/
    ]
    return mask;
  },

  percent:() =>
    createNumberMask({
        prefix: '',
        suffix: '%',
        allowDecimal: true,
        decimalLimit : 2,
        integerLimit : 3,
        allowNegative : false
    }),

  // Date in format: MM/DD/YYYY
  /**
   *
   * @description Date in format: MM/DD/YYYY
   * @returns {function(*): *[]}
   */
  date: () => rawVal => {
    let mask = [
      /[0-1]/,
      /\d/,
      "/",
      /[0-3]/,
      /\d/,
      "/",
      /[1-2]/,
      /[9]/,
      /\d/,
      /\d/
    ];

    // Dashes only added after digit after gets added
    if (rawVal.length < 3) {
      mask[2] = /\d/;
    } else if (rawVal.length < 6) {
      mask[5] = /\d/;
    }

    // Restrict day 2nd digit.
    if (rawVal[3] === "3") {
      mask[4] = /[0-1]/;
    } else if (rawVal[3] === "0") {
      mask[4] = /[1-9]/;
    }

    // Restrict month 2nd digit.
    if (rawVal[0] === "1") {
      mask[1] = /[0-2]/;
    } else if (rawVal[0] === "0") {
      mask[1] = /[1-9]/;
    }

    // Restrict year 2nd digit.
    if (rawVal[6] === "2") {
      mask[7] = /[0]/;
    }

    return mask;
  },

  // Date in format: MM/YYYY
  /**
   *
   * @description Date in format: MM/YY
   * @returns {function(*): *[]}
   */
  expDate: () => rawVal => {
    let mask = [
      /[0-1]/,
      /\d/,
      "/",
      /\d/,
      /\d/
    ];

    // Dashes only added after digit after gets added
    if (rawVal.length < 3) {
      mask[2] = /[1-2]/;
    }

    return mask;
  },

  // Alpha only mask. Can include maxLength option to restrict length
  /**
   *
   * @description Alpha only mask. Can include maxLength option to restrict length
   * @param {Object|{}}options
   * @returns {any[]|(function(*): any[])}
   */
  alpha: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|\.]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s|\.]/i);
    };
  },

  //Name mask. Allows letters, spaces, ' and -
  //TO-DO: find an elegant solution for replacing diacritics inside here
  name: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|'|-]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s'|-]/i);
    };
  },

  //Last name mask. Allows letters, spaces, periods, and -
  lastName: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|\.|-]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s|\.|-]/i);
    };
  },


  // Digit only mask. Can include maxLength option to restrict length
  // TODO: use createNumberMask instead?
  /**
   *
   * @description Digit only mask. Can include maxLength option to restrict length
   * @param {Object|{}}options
   * @returns {any[]|(function(*): any[])}
   */
  digit: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/\d/);
    }

    return raw => {
      return Array(raw.length + 1).fill(/\d/);
    };
  },

  /**
   *
   * @description Alphanumeric only mask. Can include maxLength option to restrict length
   * @param {Object|{}}options
   * @returns {any[]|(function(*): any[])}
   */
  alphaNumeric: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|\d]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s|\d]/i);
    };
  },

  /**
   *
   * @description Alphanumeric and a few special characters ('.-) only mask. Can include maxLength option to restrict length
   * @param {Object|{}}options
   * @returns {any[]|(function(*): any[])}
   */
  address: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|\d'.-]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s|\d'.-]/i);
    };
  },

  /**
   *
   * @description AlphaNumeric and a few special characters (/-) only mask. Can include maxLength option to restrict length
   * @param {Object|{}}options
   * @returns {any[]|(function(*): any[])}
   */
   accountNumber: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|\d/-]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s|\d/-]/i);
    };
  },

  // Money mask that starts input in pennies digit
  // TODO: Make vue-text-mask for right to left money
  /**
   *
   * @description Money mask that starts input in pennies digit
   * @returns {*}
   */
  money: () =>
    createNumberMask({
      requireDecimal: false,
      allowDecimal: true,
      integerLimit: 14
    }),

  moneyWithDec: () => 
    createNumberMask({
      requireDecimal: true,
      allowDecimal: true,
      integerLimit: 14
    }),


  /**
   *
   * @returns {Function}
   */
  zip: () => rawVal => {
    if (rawVal.length < 6) {
      return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    }

    return [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
  },

  /**
   *
   * @description Max length mask. Must include length option to restrict length
   * @param {Object|{}}options
   * @returns {any[]|(function(*): any[])}
   */
  maxLength: options => {
    if (options && options.length) {
      return Array(options.length).fill(/./i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/./i);
    };
  },

  /**
   *
   * @description SSN in format: 123-45-7890
   * @returns {*[]}
   */
  ssn: () => rawVal => {
    let mask = [
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/
    ]
    return mask;
  },
  alphaWithDash: options => {
    if (options && options.maxLength) {
      return Array(options.maxLength).fill(/[a-z|\s|\.|\-]/i);
    }

    return raw => {
      return Array(raw.length + 1).fill(/[a-z|\s|\.|\-]/i);
    };
  }
};
